<template>
    <div>
        <el-popover
            v-model="popVisible"
            placement="top-start"
            trigger="click">
            <div class="pop-content">
                <div>
                    <el-input 
                    type="text"
                    clearable
                    v-model="name"
                    maxlength="10"
                    show-word-limit>
                    </el-input>
                </div>
                
                <div class="pop-button">
                    <el-button type="text" @click="close">取消</el-button>
                    <el-button type="primary" @click="handleConfirm">确定</el-button>
                </div>
            </div>
            <template slot="reference">
                <div class="inline" @click.stop="handleOpen">
                    <slot></slot>
                </div>
            </template>
        </el-popover>
        
    </div>
</template>
<script>

export default {
    // 数据
    data(){
        return{
            popVisible:false,
            name:this.value,
        }
    },
    props:{
        // 输入的名字
        value:{
            type:String,
            require:true,
        }
    },
    // 方法
    methods:{
        handleOpen(){
        },
        close(){
            this.popVisible=false;
        },
        // 增加分组
        handleConfirm(){
            this.$emit("confirm",this.name);
            this.popVisible=false;
        }
    }
}
</script>
<style lang="scss" scoped>
    .pop-content{
        display:flex;
        flex-direction: row;
        .pop-button{
            margin-left: 10px;
        }
    }
</style>